import React from 'react';

// Category icons — web recreations of the iOS app's SF Symbols (see
// ios/PredictSix/Models/Question.swift `QuestionCategory.icon`):
//   Markets    → chart.line.uptrend.xyaxis
//   Politics   → building.columns
//   Sports     → sportscourt
//   Culture    → film
//   Discovery  → binoculars.fill
//   World      → globe
// All stroke `currentColor`, so they take the surrounding text color (white on
// the active gold circle, primary-text otherwise).

export default function CategoryIcon({ category, size = 22 }) {
  const common = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
  };

  switch (category) {
    case 'Markets': // chart.line.uptrend.xyaxis
      return (
        <svg {...common}>
          <path d="M4 3 V20 H21" />
          <path d="M7 15 L11 11 L14 13 L19 7" />
          <path d="M19 7 H15.4 M19 7 V10.6" />
        </svg>
      );

    case 'Politics': // building.columns
      return (
        <svg {...common}>
          <path d="M3 9 L12 4 L21 9" />
          <path d="M4 9 H20" />
          <path d="M5.5 10 V18 M9.83 10 V18 M14.17 10 V18 M18.5 10 V18" />
          <path d="M3.5 19 H20.5" />
        </svg>
      );

    case 'Sports': // sportscourt
      return (
        <svg {...common}>
          <rect x="2.5" y="5.5" width="19" height="13" rx="2" />
          <path d="M12 5.5 V18.5" />
          <circle cx="12" cy="12" r="2.6" />
        </svg>
      );

    case 'Culture': // film
      return (
        <svg {...common}>
          <rect x="3" y="4" width="18" height="16" rx="2" />
          <path d="M7.5 4 V20 M16.5 4 V20" />
          {[6.4, 10.8, 15.2].map((y) => (
            <React.Fragment key={y}>
              <rect x="4.45" y={y} width="1.6" height="1.6" rx="0.3" fill="currentColor" stroke="none" />
              <rect x="17.95" y={y} width="1.6" height="1.6" rx="0.3" fill="currentColor" stroke="none" />
            </React.Fragment>
          ))}
        </svg>
      );

    case 'Discovery': // binoculars.fill
      return (
        <svg {...common}>
          <circle cx="6.5" cy="15" r="3.5" />
          <circle cx="17.5" cy="15" r="3.5" />
          <path d="M6.5 11.5 L8.5 5.5 H10.5 L11 11.5" />
          <path d="M17.5 11.5 L15.5 5.5 H13.5 L13 11.5" />
          <path d="M11 11.5 H13" />
        </svg>
      );

    case 'World': // globe
    default:
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" />
          <path d="M3 12 H21" />
          <ellipse cx="12" cy="12" rx="4" ry="9" />
        </svg>
      );
  }
}
